import { SearchParams } from '@/types/common'
import { CreateHistorical, UpdateHistorical } from '@/types/historical'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const etReferenceDataConfig = {
  getAll(searchParams: SearchParams = {}) {
    const url = '/api/etreference'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: string, id: string) {
    const url = `/api/etreference/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateHistorical) {
    const url = `/api/etreference/${payload.interfaceId}`
    return axiosClient.post(url, payload)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/etreference/${interfaceId}/${id}`
    return axiosClient.delete(url)
  },
  update(payload: UpdateHistorical) {
    const url = `/api/etreference/${payload.interfaceId}/${payload.id}`
    return axiosClient.put(url, payload)
  },
}

export default etReferenceDataConfig
